if (!customElements.get('bandelle-navigation')) {
 customElements.define('bandelle-navigation', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();
   this.abort = new AbortController();
   if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.abort.signal });
   } else {
    this.initialize();
   }
  }
  initialize() {
   if (!this.isConnected || this.abort.signal.aborted) return;
   const options = { signal: this.abort.signal };
   const menus = Array.from(this.querySelectorAll('.bn-header__dropdown'));
   const desktop = () => matchMedia('(min-width:1200px)').matches;
   const hover = () => desktop() && matchMedia('(any-hover:hover) and (any-pointer:fine)').matches;
   menus.forEach(menu => {
    let timer;
    const summary = menu.querySelector('summary');
    const close = () => { clearTimeout(timer); menu.open = false; };
    const open = () => {
     clearTimeout(timer);
     menus.forEach(other => { if (other !== menu) other.open = false; });
     menu.open = true;
    };
    menu.addEventListener('pointerenter', event => { if (desktop() && event.pointerType === 'mouse') open(); }, options);
    menu.addEventListener('pointerleave', event => {
     if (!desktop() || event.pointerType !== 'mouse') return;
     timer = setTimeout(() => { if (!menu.contains(document.activeElement)) close(); }, 300);
    }, options);
    menu.addEventListener('focusin', () => { if (hover()) open(); }, options);
    menu.addEventListener('focusout', event => {
     if (!menu.contains(event.relatedTarget) && !menu.matches(':hover')) close();
    }, options);
    summary.addEventListener('click', event => {
     if (hover()) { event.preventDefault(); open(); }
    }, options);
    menu.addEventListener('keydown', event => {
     if (event.key === 'Escape') { event.preventDefault(); summary.focus(); close(); }
    }, options);
    menu.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(menu.open)), options);
    summary.setAttribute('aria-expanded', String(menu.open));
    this.abort.signal.addEventListener('abort', () => clearTimeout(timer), {once:true});
   });
   document.addEventListener('pointerdown', event => {
    if (!this.contains(event.target)) menus.forEach(menu => {menu.open = false;});
   }, options);
  }
  disconnectedCallback() { this.abort?.abort(); }
 });
}
